/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetChatUsageQueryResponse, ReportingControllerGetChatUsageQueryParams, ReportingControllerGetChatUsage400, ReportingControllerGetChatUsage401, ReportingControllerGetChatUsage403, ReportingControllerGetChatUsage404 } from "../../models/reportingController/ReportingControllerGetChatUsage";

function getReportingControllerGetChatUsageUrl() {
  const res = { method: 'GET', url: `/api/v1/reporting/chats` as const }  
  return res
}

/**
 * @summary Get chat usage for an organization: Project Assist and document-level messages, distinct threads and users, a bucketed series, a per-team breakdown and the previous-period comparison. Honors the team and date filters.
 * {@link /api/v1/reporting/chats}
 */
export async function reportingControllerGetChatUsage(params: ReportingControllerGetChatUsageQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ReportingControllerGetChatUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetChatUsage400 | ReportingControllerGetChatUsage401 | ReportingControllerGetChatUsage403 | ReportingControllerGetChatUsage404>, unknown>({ method : "GET", url : getReportingControllerGetChatUsageUrl().url.toString(), params, ... requestConfig })  
  return res.data
}